import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import Swal from 'sweetalert2'

@Component({
    selector: 'app-advance',
    templateUrl: './advance.component.html',
    styleUrls: ['./advance.component.css'],
    standalone: false
})
export class AdvanceComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;
  items: any[] = [];
  employees: any[] = [];
  token: any;

  new_item = {
    employee_id: null,
    amount: 0,
    status: 'INACTIVE'
  }

  item = {
    employee_id: null,
    amount: 0
  }

  new_item_id: number = 0;
  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, id: any) {
    this.modalService.open(content);

    let Item = this.items.find(i => i.salary.id === id);

    this.new_item_id = Item.salary.id;
    this.new_item = Item.salary;
  }

  async ngOnInit(): Promise<void> {
    this.getItems();
  }

  async getItems() {
    this.utility.loading = true;
    const sub = this.api.get('salarys/advance', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects;
        this.list_length = this.items.length;
      },
      async error => {
        alert(error);
      }
    );
    sub.add(() => { this.getEmployess() });
  }

  async getEmployess() {
    const sub = this.api.get('employees/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.employees = objects;
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  async onDelete(id: any) {
    if (confirm("Delete this item?")) {
      this.api.delete('salarys/advance/' + id, this.token).subscribe(
        async data => {
          this.getItems();
          Swal.fire({
            title: 'Success!',
            text: 'Advance Salary Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }

  async OnSubmit() {
    const body = {
      employee_id: this.item.employee_id,
      amount: this.item.amount
    }

    this.api.post("salarys/advance/", body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Advance Salary Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async OnUpdate(id: any) {
    const body = {
      employee_id: this.new_item.employee_id,
      amount: this.new_item.amount,
      status: this.new_item.status
    }

    this.api.update("salarys/advance/" + id, body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Advance Salary Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  isAdmin() {
    let role = localStorage.getItem('role');

    if (role === 'admin')
      return true;
    return false;
  }
}
